// ─────────────────────────────────────────────────────────────
// BUILDER PROJECT TYPES — EDIT TO UPDATE PHOTOS PER CATEGORY
// ─────────────────────────────────────────────────────────────
// Every image here MUST be a kitchen / wardrobe / joinery
// interior — never a building exterior, living room or city
// skyline. All images below have been visually verified.
// Each category has multiple images. The first is shown in the
// carousel by default; clicking the photo opens a lightbox with
// every image in that category's `images` array.
// ─────────────────────────────────────────────────────────────

import {
  Home,
  Building2,
  Building,
  LayoutGrid,
  Hotel,
  Briefcase,
} from "lucide-react";

export const BUILDER_PROJECTS = [
  {
    id: "custom-homes",
    label: "Custom homes",
    icon: Home,
    description:
      "Bespoke joinery, top to bottom — designed for the family that will live in it.",
    images: [
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=85",
      "https://images.pexels.com/photos/35189709/pexels-photo-35189709.jpeg?auto=compress&cs=tinysrgb&w=1800",
      "https://images.unsplash.com/photo-1683629357963-adf2b1fa9ad9?auto=format&fit=crop&w=1800&q=85",
      "https://images.pexels.com/photos/37030080/pexels-photo-37030080.jpeg?auto=compress&cs=tinysrgb&w=1800",
    ],
  },
  {
    id: "duplexes",
    label: "Duplexes",
    icon: Building2,
    description:
      "Two homes, one program. Mirrored joinery delivered in a single window.",
    // Kitchen interiors (previous version had a house exterior — removed).
    images: [
      "https://images.pexels.com/photos/280239/pexels-photo-280239.jpeg?auto=compress&cs=tinysrgb&w=1800",
      "https://images.unsplash.com/photo-1683629357963-adf2b1fa9ad9?auto=format&fit=crop&w=1800&q=85",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1800&q=85",
    ],
  },
  {
    id: "townhouses",
    label: "Townhouses",
    icon: Building,
    description:
      "Six to twelve homes, staged installs, identical finish on every door.",
    images: [
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1800&q=85",
      "https://images.pexels.com/photos/280239/pexels-photo-280239.jpeg?auto=compress&cs=tinysrgb&w=1800",
      "https://images.pexels.com/photos/10486222/pexels-photo-10486222.jpeg?auto=compress&cs=tinysrgb&w=1800",
    ],
  },
  {
    id: "multi-unit",
    label: "Multi-unit developments",
    icon: LayoutGrid,
    description:
      "Mid-rise volume with builder-grade reliability. Tendered, scheduled, delivered.",
    // Kitchen interiors (previous version had an apartment exterior + a
    // living-room shot — both removed).
    images: [
      "https://images.pexels.com/photos/1358900/pexels-photo-1358900.jpeg?auto=compress&cs=tinysrgb&w=1800",
      "https://images.pexels.com/photos/35189709/pexels-photo-35189709.jpeg?auto=compress&cs=tinysrgb&w=1800",
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1800&q=85",
    ],
  },
  {
    id: "apartments",
    label: "Apartments",
    icon: Hotel,
    description:
      "High-density kitchens and robes engineered for repeat install at scale.",
    // Kitchen interiors (previous version was building exteriors + a 404).
    images: [
      "https://images.pexels.com/photos/1358900/pexels-photo-1358900.jpeg?auto=compress&cs=tinysrgb&w=1800",
      "https://images.pexels.com/photos/10486222/pexels-photo-10486222.jpeg?auto=compress&cs=tinysrgb&w=1800",
      "https://images.unsplash.com/photo-1683629357963-adf2b1fa9ad9?auto=format&fit=crop&w=1800&q=85",
    ],
  },
  {
    id: "commercial",
    label: "Commercial fit-outs",
    icon: Briefcase,
    description:
      "Hospitality, healthcare, workplace. Joinery that meets a commercial spec.",
    // Hospitality + office joinery interiors (previous version had a
    // Toronto cityscape — removed).
    images: [
      "https://images.unsplash.com/photo-1521017432531-fbd92d768814?auto=format&fit=crop&w=1800&q=85",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1800&q=85",
      "https://images.unsplash.com/photo-1556912173-3bb406ef7e77?auto=format&fit=crop&w=1800&q=85",
    ],
  },
];
